import { type RefObject, useEffect, useState } from 'react';

export const useVisibleSections = (
  slideRefs: Map<string, RefObject<HTMLDivElement | null>>,
  sections: { id: string }[]
) => {
  const [visibleSubSections, setVisibleSubSections] = useState<Set<string>>(new Set());

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const subsectionId = entry.target.getAttribute('data-id');
          if (entry.isIntersecting && subsectionId) {
            setVisibleSubSections((prev) => {
              return new Set([...prev, subsectionId]);
            });
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.1 }
    );

    slideRefs.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      return observer.disconnect();
    };
  }, [sections, slideRefs]);

  return { visibleSubSections };
};
